import { select } from "d3-selection";
import { stylize } from "d3plus-common";
/**
    @class Message
    @desc Displays a message using plain HTML.
    @private
*/

var Message = function Message() {
  this._isVisible = false;
};
/**
    @memberof Message
    @desc Removes the message from the page.
    @chainable
*/


Message.prototype.exit = function exit(elem, duration) {
  elem.transition().duration(duration).style("opacity", 0).transition().remove();
  this._isVisible = false;
};
/**
    @memberof Message
    @desc Removes the message from the page.
    @chainable
*/


Message.prototype.hide = function hide(ref) {
  if (ref === void 0) ref = {};
  var duration = ref.duration;
  if (duration === void 0) duration = 600;
  var callback = ref.callback;
  this.mask.call(this.exit.bind(this), duration);
  this.elem.call(this.exit.bind(this), duration);

  if (callback) {
    setTimeout(callback, duration + 100);
  }

  this._isVisible = false;
  return this;
};
/**
    @memberof Message
    @desc Draws the message given the specified configuration.
    @param {Object} [*config*]
    @chainable
*/


Message.prototype.render = function render(ref) {
  if (ref === void 0) ref = {};
  var callback = ref.callback;
  var container = ref.container;
  if (container === void 0) container = "body";
  var duration = ref.duration;
  if (duration === void 0) duration = 600;
  var html = ref.html;
  if (html === void 0) html = "Please Wait";
  var mask = ref.mask;
  if (mask === void 0) mask = "rgba(0, 0, 0, 0.1)";
  var style = ref.style;
  if (style === void 0) style = {};
  var parent = select(container).style("position", "relative");
  this.mask = parent.selectAll("div.d3plus-Mask").data(mask ? [mask] : []);
  this.mask = this.mask.enter().append("div").attr("class", "d3plus-Mask").style("opacity", 1).merge(this.mask);
  this.mask.exit().call(this.exit.bind(this), duration);
  stylize(this.mask, {
    "background-color": String,
    "bottom": "0px",
    "left": "0px",
    "position": "absolute",
    "right": "0px",
    "top": "0px"
  });
  this.elem = parent.selectAll("div.d3plus-Message").data([html]);
  this.elem = this.elem.enter().append("div").attr("class", "d3plus-Message").style("opacity", 1).merge(this.elem).html(String);
  stylize(this.elem, style);

  if (callback) {
    setTimeout(callback, 100);
  }

  this._isVisible = true;
  return this;
};

export default Message;